<template>
  <Header :name="$t('user.your_cards.sub_heading', 1)"/>

  <div class="container my-5">
    <div class="flex items-center justify-between gap-4">
      <h1 class="mb-5">
        {{ $t('user.your_cards.heading', 2) }}
      </h1>

      <AppAddCard/>
    </div>

    <CardsList/>
  </div>
</template>

<script>
import Header from '@/components/Functional/Header'
import CardsList from '@/components/Credits/CardsList'
import { mapState } from 'pinia'
import { usePaymentStore } from '@/stores/payment'
import AppAddCard from '@/components/App/AppAddCard.vue'

export default {
  name: 'SaveCards',
  components: {
    Header,
    CardsList,
    AppAddCard
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(usePaymentStore, [
      'paymentMethods'
    ])
  },
  beforeCreate () {
    document.title = 'Checkout'
  },
  mounted () {
  },
  methods: {
  }
}
</script>

